
import { Component, Prop, Vue } from "vue-property-decorator";
import CashboxTransferForm from "@/form/finance/cashbox/CashboxTransferForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import moment from 'moment';
@Component({
  components: { FormGroup },
  methods: { moment }
})
export default class CashboxTransferComponent extends Vue {
  @Prop() readonly form!: CashboxTransferForm;

  searchTarget(val: any): void {
  }

  onChange(event: any): void {
  }

  onNumberChange(val: string): void {
    if (this.form.sum) {
      let value = this.form.sum.toString();
      this.form.sum = value.replace(/\D/gi, '');
      if (!this.form.sum) {
        this.form.sum = '0';
      }
      if (value.startsWith('0')) {
        this.form.sum = value.substring(1);
      }
    }
  }
}
